export default [
  {
    path: '/client/campaigns',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-campaigns" */ "@/views/client/Campaigns.vue")
  }
]
